import { IdentityValidationWizard } from './components/flows/identity-validation-wizard';
import { MagicLinkWizardSessionManager } from './components/flows/magic-link-wizard-session-manager';

export const App = () => {
  const isIdentityValidationFlow = window.location.pathname.startsWith('/validar/');
  return isIdentityValidationFlow ? <IdentityValidationWizard /> : <MagicLinkWizardSessionManager />;
};
